<template>
  <component v-if="authAction" :is="authAction"></component>
</template>

<script>
import ResetPassword from "./ResetPassword";
import VerifyEmail from "./VerifyEmail";

export default {
  components: {
    ResetPassword,
    VerifyEmail
  },
  data: () => ({
    authAction: false
  }),
  created() {
    const mode = this.$route.query.mode;
    if (mode === "verifyEmail") {
      this.authAction = "VerifyEmail";
    } else if (mode === "resetPassword") {
      this.authAction = "ResetPassword";
    } else {
      this.$router.push("/");
    }
  }
};
</script>
